module.exports = __webpack_public_path__ + "static/media/icon-account.d1b4fce5.svg";